import {LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class RoutingOptions extends BaseComponent {
	
	static get styles() {
		return css`
			:host {
				display: block;
				box-sizing: border-box;
				height: 100%;
				max-width: 100%;
				min-width: 0;
				overflow: auto;
			}

			.routing-options-root {
				padding: 10px;
				box-sizing: border-box;
				max-width: 100%;
				min-width: 0;
			}

			.routing-options-actions {
				text-align: center;
			}
		`;
	}
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var routingOptions = this;
		setTimeout(function(){
			routingOptions.init();
		});
	}
	
	render() {	
		return html`
			<div class="routing-options-root">				
				<slot name='form'></slot>
				<div class="routing-options-actions">
					<slot name='buttons'></slot>
				</div>
			</div>	
		`;
	}
	
	init() {
		var routingOptions = this;
		
		var optionForm = ElementUtil.create({
			tag: 'dl-routing-options-form',
			slot: 'form',
			listeners: {
				ready: function() {
					var loadOptions = function(companyId) {
						RoutingService.getGeospatialOptionsService().getOptions(companyId).then(function(options){
							optionForm.loadOptions(options);				
						});
					};		

					if (routingOptions.admin) {			
						loadOptions();
					} else {
						Service.getCompanyService().getCurrentCompany().then(function(companyFull){
							loadOptions(companyFull.company.companyId);		
						});
					}		
				}
			}
		});		
		routingOptions.append(optionForm);
		
		var button = ElementUtil.create({
			tag: 'vaadin-button',
			theme: 'primary',
			slot: 'buttons',
			children: [
				ElementUtil.makeIcon('vaadin:database', ' Save')
			],
			listeners: {
				click: function() {
					
					//get form
					var options = optionForm.getOptions();					
					
					var saveOptions = function() {
						var loadMask = optionForm.showLoading('Saving...');						
						RoutingService.getGeospatialOptionsService().saveOptions(options, (options.engineOptionsId ? true : false)).then(function(result){
							loadMask.remove();
							
							if (result && 
								result.errors && 
								result.success === false) {							
								//ignore default error handling will notify user
							} else {
								window.DL.MessageUtil.showToast('Success', 'Saved Routing Options', {
									theme: 'success',
									position: 'top-stretch'
								});					
							}
						});
					};
					
					if (routingOptions.admin) {
						saveOptions();
					} else {
						Service.getCompanyService().getCurrentCompany().then(function(companyFull){
							options.companyId = companyFull.company.companyId;
							saveOptions();
						});						
					}
					
					
				}
			}
		});
		routingOptions.append(button);
		

	}
	
}
customElements.define('dl-routing-options', RoutingOptions);
